import React, { memo, useRef, useEffect, useCallback, useState} from 'react';
import {WIDTH, HEIGHT, PADDING} from './constants.js';

export const useForces = (effect, ctxt) => {
    const getForceParameters = (forceNumber) => {
        let parameters = effect.groups.flatMap(
            g => g.variables.filter(
                x => x.name.includes('force')));

        let forceParameters = parameters.filter(
            x => x.name.includes(new String(forceNumber)));

        let x = forceParameters.find(x => x.name.includes('force.x'));
        let y = forceParameters.find(x => x.name.includes('force.y'));
        let dx = forceParameters.find(x => x.name.includes('force.dx'));
        let dy = forceParameters.find(x => x.name.includes('force.dy'));
        return [x,y,dx,dy];
    };

    let drawForces = (ctxt) => {
        let parameters = effect.groups.flatMap(
            g => g.variables.filter(
                x => x.name.includes('force')));

        let numForces = parameters.length / 4;
        let forceCircles = [];
        for (let i=1; i <= numForces; i++ ){
            let forceParameters = parameters.filter(
                x => x.name.includes(new String(i)));

            let x1 = forceParameters.find(x => x.name.includes('force.x')).get();
            let y1 = HEIGHT - forceParameters.find(x => x.name.includes('force.y')).get();
            let dx = forceParameters.find(x => x.name.includes('force.dx')).get();
            let dy = -1 * forceParameters.find(x => x.name.includes('force.dy')).get();

            dx *= 0.25;
            dy *= 0.25;

            let x2 = x1 + dx;
            let y2 = y1 + dy;


            // now draw the path
            ctxt.beginPath();

            ctxt.strokeStyle = 'white';
            ctxt.lineWidth = 2;
            canvas_arrow(ctxt, x1, y1, x2, y2);
            ctxt.stroke();

            let startCircle = new Path2D();
            startCircle.arc(x1,y1, 5, 0, Math.PI * 2);
            ctxt.fillStyle = 'white';
            ctxt.fill(startCircle);

            let endCircle = new Path2D();
            endCircle.arc(x2,y2, 14, 0, Math.PI * 2);
            ctxt.fillStyle = 'transparent';
            ctxt.fill(endCircle);

            forceCircles.push({
                start: startCircle,
                end: endCircle});
        }
        return forceCircles;
    };

    function canvas_arrow(context, fromx, fromy, tox, toy) {
        var headlen = 10; // length of head in pixels
        var dx = tox - fromx;
        var dy = toy - fromy;
        var angle = Math.atan2(dy, dx);
        context.moveTo(fromx, fromy);
        context.lineTo(tox, toy);
        context.lineTo(tox - headlen * Math.cos(angle - Math.PI / 6), toy - headlen * Math.sin(angle - Math.PI / 6));
        context.moveTo(tox, toy);
        context.lineTo(tox - headlen * Math.cos(angle + Math.PI / 6), toy - headlen * Math.sin(angle + Math.PI / 6));
    }

    return {drawForces, getForceParameters};
};
